import React from "react";
import TransactionImg from "../component/images/transactionImg";
import VendorImg from "../component/images/vendorImg";
import SettingImg from "../component/images/settingImg";
import LoanImg from "../component/images/loanImg";
import AssetsImg from "../component/images/assetsImg";
import TransfersImg from "../component/images/transferImg";
import Sidebar from "../component/manager/sidebar";
import AllTransaction from "../component/manager/pages/allTransaction";
import Loan from "../component/manager/pages/loan";
import Assets from "../component/manager/pages/assets";
import Settings from "../component/manager/pages/settings";
import Vendors from "../component/manager/pages/vendors";
import Transfers from "../component/manager/pages/transfer";
import { Routes, Route, useNavigate } from "react-router-dom";

const Manager = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      img: TransactionImg,
      title: "All Transcation",
      key: "Transaction",
      route: "/manager/transactions",
    },
    {
      img: LoanImg,
      title: "Loan",
      key: "Loan",
      route: "/manager/loan",
    },
    {
      img: AssetsImg,
      title: "Assets",
      key: "Assets",
      route: "/manager/assets",
    },
    {
      img: SettingImg,
      title: "Settings",
      key: "Settings",
      route: "/manager/settings",
    },
    {
      img: VendorImg,
      title: "Vendors",
      key: "Vendors",
      route: "/manager/vendors",
    },
    {
      img: TransfersImg,
      title: "Transfers",
      key: "Transfers",
      route: "/manager/transfers",
    },
  ];

  return (
    <div className="flex">
      <Sidebar
        menuItems={menuItems}
        onMenuItemClick={(route) => navigate(route)}
      />
      <div className="w-full">
        <Routes>
          <Route path="/transactions" element={<AllTransaction />} />
          <Route path="/loan" element={<Loan />} />
          <Route path="/assets" element={<Assets />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/vendors" element={<Vendors />} />
          <Route path="/transfers" element={<Transfers />} />
        </Routes>
      </div>
    </div>
  );
};

export default Manager;
